import { createMarkup } from '@packages/domain/utils/createMarkup/createMarkup';
import { Box } from 'components/Box/Box';
import { Instructions } from 'components/InstructionUI/InstructionUI';
import { Amount } from 'containers';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';

function OnlineScript({
  embeddedScript,
  i18n,
  locale,
  offerName,
  isOppOfferSelected = false,
  price,
  publicKey,
  scriptSignature,
  uuidTokenInstruction,
}) {
  const scriptEle = React.useRef();
  const { Script } = Instructions;
  const uuidToken = uuidTokenInstruction?.value;

  // biome-ignore lint/correctness/useExhaustiveDependencies: locale triggers i18n update, setCtaCopy is stable
  useEffect(() => {
    const copy = i18n.t('online.payWith', { offerName });
    const ctas = scriptEle?.current?.getElementsByClassName('payButton') || [];

    for (let i = 0; i < ctas.length; i++) {
      setCtaCopy(ctas.item(i), copy);
    }
  }, [offerName, locale, i18n]);

  function setCtaCopy(cta, copy) {
    cta.value = copy;
    if (cta.nodeName !== 'INPUT') {
      cta.textContent = copy;
    }
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: Script is stable, scriptEle ref is intentionally included for re-render
  const script = useMemo(
    () => (
      <Script
        id="payment"
        code={embeddedScript.value}
        className="EmbeddedScript"
        publicKey={publicKey}
        signature={scriptSignature.value}
        scriptProps={{ locale, uuidToken }}
        forwardRef={scriptEle}
        data-locale={locale}
      />
    ),
    [
      scriptEle,
      embeddedScript.value,
      locale,
      publicKey,
      scriptSignature.value,
      uuidToken,
    ],
  );
  return (
    <>
      {script}

      {isOppOfferSelected && (
        <Box className="EmbeddedScript-amountBox">
          <div>
            <p
              className="EmbeddedScript-chargeHint"
              dangerouslySetInnerHTML={createMarkup(
                i18n.t('online.script.chargeHint'),
              )}
            />
          </div>
          <div>
            <p className="margin-0 fontSize-sm">
              {i18n.t('online.script.total')}
            </p>
            <span className="EmbeddedScript-amount">
              <Amount currency={price.currency} value={price.value} />
            </span>
          </div>
        </Box>
      )}
    </>
  );
}

OnlineScript.propTypes = {
  embeddedScript: PropTypes.object,
  i18n: PropTypes.shape({ t: PropTypes.func.isRequired }),
  isOppOfferSelected: PropTypes.bool,
  locale: PropTypes.string,
  offerName: PropTypes.string,
  price: PropTypes.object.isRequired,
  publicKey: PropTypes.string,
  redirectUrl: PropTypes.shape({
    value: PropTypes.string,
  }),
  scriptSignature: PropTypes.object,
  uuidTokenInstruction: PropTypes.object,
};

export { OnlineScript };
